export enum MarketingShotSearchOrderingEnum {
    CODE = 'code',
    START_DATE = 'startDate',
    SCHEDULE_DATE = 'scheduleDate'
}
